import React from 'react';
const Notfound = () => <h1>Oops.. 404</h1>;
export default Notfound;